import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { CellContext } from '@tanstack/react-table';

export interface ChargePointsSiteCellProps
  extends CellContext<
    GatewayChargePointInMaintenanceModel,
    GatewayChargePointInMaintenanceModel['location']
  > {}

export const ChargePointsSiteCell = (
  props: ChargePointsSiteCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return <Text truncate>{getValue()?.name ?? '-'}</Text>;
};
